module.exports = __webpack_public_path__ + "assets/chuchashenpi.734ca571.svg";